import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { chatMessengerInfo, messengerPatientsInfo, ReceiveMessengerInfo } from 'src/app/models/IMessaging';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-patient-messenger',
  templateUrl: './patient-messenger.component.html',
  styleUrls: ['./patient-messenger.component.css']
})
export class PatientMessengerComponent implements OnInit {
  PatientMessengerForm: FormGroup;
  messengerPatList:messengerPatientsInfo[] = [];
  messengerMaterPatList:messengerPatientsInfo[] = [];
  pendingMessengerList:messengerPatientsInfo[] = [];
  pendingmessengerMaterList:messengerPatientsInfo[] = [];
  receivemessengerList:ReceiveMessengerInfo[] = [];
  senderMessengerList:chatMessengerInfo[] = [];
  result: any;
  patId: number; PatientName:string; PatAddress:string;
  providerId: string;
  fromNo: string;
  constructor(private fb: FormBuilder, private msgservice: MessagesService
    , private toastr: ToastrService) { }

  ngOnInit() {
    this.PatientMessengerForm = this.fb.group({
      searchtxt: '',
      messagetxt:'',
    });
    this.GetAllMessengerPatientInfo();
    this.GetPendingMessengerPatientInfo();
    $('#allview').hide();
   }

   GetAllMessengerPatientInfo() {
    this.msgservice.getAllmessengersPatInfo().subscribe(msgpatInfo => {
      this.messengerPatList = msgpatInfo;
      this.messengerMaterPatList = msgpatInfo;
    },
      (err: any) => console.log(err)
    );
  }

  GetPendingMessengerPatientInfo() {
    this.msgservice.getPendingmessengersPatInfo().subscribe(pendmsgpatInfo => {
      this.pendingMessengerList = pendmsgpatInfo;
      this.pendingmessengerMaterList = pendmsgpatInfo;
    },
      (err: any) => console.log(err)
    );
  }

  onMessengerPhoneNoClick(phoneNo, patientId, patInfo:messengerPatientsInfo){
    if(patInfo != null){
      this.PatientName = patInfo.PatientName;
      this.PatAddress = patInfo.PatAddress;
      this.patId = patInfo.PatientId;
    }
    if(phoneNo.includes('-')){
      phoneNo = phoneNo.replace('-','').replace('-','');
    }
    this.fromNo = phoneNo;
    this.msgservice.getReceiveMessengersPatInfo(phoneNo, patientId).subscribe(data => {
      if(data != null && data.length > 0){
        this.receivemessengerList = data;          
      }  
      else {
        this.receivemessengerList = [];
      }   
      this.getSenderMessageInfo(phoneNo, patientId);
    },
      (err: any) => console.log(err)
    );
  }

  searchfilterevent(event){
    let txt = event.target.value.toString();
     let obj: messengerPatientsInfo[] = [];  
     let obj1: messengerPatientsInfo[] = [];   
     if (txt == '') {
       obj = this.messengerMaterPatList;
       obj1 = this.pendingmessengerMaterList;
     } else {
       obj = this.messengerMaterPatList.filter(x => x.PatientName.toLowerCase().includes(txt));
       obj1 = this.pendingmessengerMaterList.filter(x => x.PatientName.toLowerCase().includes(txt));
     }    
     this.messengerPatList = obj;
     this.pendingmessengerMaterList = obj1;
  }

  SendMessage(){
    var patientMessaenger: chatMessengerInfo = this.PatientMessengerForm.value;
    patientMessaenger.message = this.PatientMessengerForm.value.messagetxt;
    patientMessaenger.patientId = this.patId;
    patientMessaenger.prividerId = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    patientMessaenger.from = this.fromNo;
    this.msgservice.insertMessengersPatInfo(patientMessaenger).subscribe(data => {
      this.result = data;
      this.toastr.success(this.result);
      this.getSenderMessageInfo(this.fromNo, this.patId);
      this.clearMessage();
    },
      (err: any) => console.log(err)
    );
  }

  getSenderMessageInfo(phoneNo, patientId){
    this.msgservice.getSenderMessageInfo(phoneNo, patientId).subscribe(data => {
      if(data != null && data.length > 0)
      this.senderMessengerList = data;
      else
      this.senderMessengerList = [];
    },
      (err: any) => console.log(err)
    );
  }

  clearMessage(){
    this.PatientMessengerForm.patchValue({
      messagetxt:'',
    })
  }
  
  showtask() {
    $('.informationoftask').show();
    $('#close-contact-information').hide();

  }
  allview() {
    this.GetAllMessengerPatientInfo();
    this.PatientName = '';
    this.PatAddress = '';
    this.patId = 0;
    this.receivemessengerList = [];
    this.senderMessengerList = [];
    $('#allview').show();
    $('#pendingview').hide();
  }
  pendingview() {
    this.GetPendingMessengerPatientInfo();
    this.PatientName = '';
    this.PatAddress = '';
    this.patId = 0;
    this.receivemessengerList = [];
    this.senderMessengerList = [];
    $('#allview').hide();
    $('#pendingview').show();
  }


}
